import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const ProgressBar = ({ progress, size, background, withLabel, reverse, text, colorBar, ariaLabel }) => {
  return (
    <div
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
      className={clsx(`progress-bar progress-bar--size-${size}`, `progress-bar--background-${background}`, { 'progress-bar--reverse': reverse })}
    >
      {text && <span className="progress-bar__text">{text}</span>}
      <div className="progress-bar__bar">
        <div className="progress-bar__progress" style={{ width: progress + '%', backgroundColor: colorBar }}></div>
      </div>
      {withLabel && <div className="progress-bar__label">{progress}% </div>}
    </div>
  );
};

ProgressBar.propTypes = {
  ariaLabel: PropTypes.string,
  background: PropTypes.oneOf(['default', 'white', 'grey']),
  colorBar: PropTypes.string,
  progress: PropTypes.number,
  reverse: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'medium']),
  text: PropTypes.string,
  withLabel: PropTypes.bool,
};

ProgressBar.defaultProps = {
  progress: 10,
  size: 'default',
  background: 'default',
  withLabel: true,
  reverse: false,
};

export default ProgressBar;
